"use strict";

var _interopRequireDefault = require("/www/wwwroot/python/front/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/www/wwwroot/python/front/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _user = require("@/api/user");
var _default = exports.default = {
  components: {},
  props: [],
  data: function data() {
    return {
      formData: {
        old_password: undefined,
        new_password1: undefined,
        new_password2: undefined
      },
      rules: {
        old_password: [{
          required: true,
          message: '请输入旧密码',
          trigger: 'blur'
        }],
        new_password1: [{
          required: true,
          message: '请输入新密码',
          trigger: 'blur'
        }],
        new_password2: [{
          required: true,
          message: '请再次输入新密码',
          trigger: 'blur'
        }]
      }
    };
  },
  computed: {},
  watch: {},
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    submitForm: function submitForm() {
      var _this = this;
      this.$refs['elForm'].validate(function (valid) {
        if (!valid) return;
        // TODO 提交表单
        (0, _user.changePassword)(_this.formData).then( /*#__PURE__*/function () {
          var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(res) {
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  _this.$message({
                    message: '密码修改成功,请重新登陆',
                    type: 'success'
                  });
                  _context.next = 3;
                  return _this.$store.dispatch('user/logout');
                case 3:
                  _this.$router.push("/login");
                case 4:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          }));
          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());
      });
    },
    resetForm: function resetForm() {
      this.$refs['elForm'].resetFields();
    }
  }
};